(() => {
  function init(scope) {
    const root = scope.querySelector('#lr-carta-completa');
    if (!root || root.dataset.lrMenuReady) return;
    root.dataset.lrMenuReady = 'true';
    const links = [...root.querySelectorAll('.lr-complete-index a')];
    root.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', event => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        links.forEach(item => {
          if (item === link) item.setAttribute('aria-current', 'location');
          else item.removeAttribute('aria-current');
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
